// Thin client for the console API. Every call goes through the injected
// fetch (auth.fetch), so the bearer rides along in keycloak mode.

export class ApiError extends Error {
  constructor(status, message, detail = null) {
    super(message);
    this.status = status;
    this.detail = detail; // the server's `detail` when it is structured
  }
}

async function check(res) {
  if (res.ok) return res;
  let detail = `${res.status} ${res.statusText || ""}`.trim();
  let structured = null;
  try {
    const body = await res.json();
    if (body && body.detail) {
      if (Array.isArray(body.detail)) {
        detail = body.detail.map((d) => `${(d.loc || []).slice(1).join(".")}: ${d.msg}`).join("; ");
      } else if (typeof body.detail === "object") {
        structured = body.detail;
        detail = String(body.detail.message || JSON.stringify(body.detail));
      } else {
        detail = String(body.detail);
      }
    }
  } catch { /* not JSON */ }
  throw new ApiError(res.status, detail, structured);
}

export function createApi(base, fetchImpl) {
  const url = (p) => `${base}${p}`;
  const getJson = async (p) => (await check(await fetchImpl(url(p)))).json();
  return {
    catalog: () => getJson("/v1/catalog"),
    me: () => getJson("/v1/me"),
    listIssues: () => getJson("/v1/issues").then((b) => b.issues),
    getIssue: (id) => getJson(`/v1/issues/${encodeURIComponent(id)}`),
    alerts: (id) => getJson(`/v1/issues/${encodeURIComponent(id)}/alerts.geojson`),
    observations: (id) => getJson(`/v1/issues/${encodeURIComponent(id)}/observations.geojson`),
    field: (id, param, hour, maxPoints) =>
      getJson(`/v1/issues/${encodeURIComponent(id)}/fields/${encodeURIComponent(param)}/${hour}.json${maxPoints ? `?max_points=${maxPoints}` : ""}`),
    issue: async (body) =>
      (await check(await fetchImpl(url("/v1/issues"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }))).json(),
    reissueAlerts: async (id) =>
      (await check(await fetchImpl(url(`/v1/issues/${encodeURIComponent(id)}/reissue-alerts`), { method: "POST" }))).json(),
    downloadBlob: async (id) => (await check(await fetchImpl(url(`/v1/issues/${encodeURIComponent(id)}/download.zip`)))).blob(),
  };
}
